import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut, Sprout } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#FBF9F6]/80 border-b border-[#E6E2D8]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <Link
          to={user ? "/dashboard" : "/"}
          data-testid="logo-link"
          className="flex items-center gap-2 text-[#2D2926]"
        >
          <Sprout className="text-[#D4A574]" size={26} strokeWidth={1.5} />
          <span className="font-serif text-3xl tracking-tight">Colleague</span>
        </Link>
        <nav className="flex items-center gap-2">
          {user ? (
            <>
              <Link
                to="/dashboard"
                data-testid="nav-dashboard"
                className="hidden sm:inline text-sm text-[#6B655D] hover:text-[#2D2926] hover:bg-[#F2EFE9] rounded-full px-4 py-2 transition-colors"
              >
                Dashboard
              </Link>
              <Link
                to="/mood"
                data-testid="nav-mood"
                className="hidden sm:inline text-sm text-[#6B655D] hover:text-[#2D2926] hover:bg-[#F2EFE9] rounded-full px-4 py-2 transition-colors"
              >
                Vibe
              </Link>
              <Link
                to="/feedback"
                data-testid="nav-feedback"
                className="hidden sm:inline text-sm text-[#6B655D] hover:text-[#2D2926] hover:bg-[#F2EFE9] rounded-full px-4 py-2 transition-colors"
              >
                Feedback
              </Link>
              <Link
                to="/profile"
                data-testid="nav-profile"
                className="hidden sm:inline text-sm text-[#6B655D] hover:text-[#2D2926] hover:bg-[#F2EFE9] rounded-full px-4 py-2 transition-colors"
              >
                Profile
              </Link>
              <Link
                to="/account"
                data-testid="nav-account"
                className="hidden sm:inline text-sm text-[#6B655D] hover:text-[#2D2926] hover:bg-[#F2EFE9] rounded-full px-4 py-2 transition-colors"
              >
                Account
              </Link>
              <div
                data-testid="nav-user"
                className="ml-2 flex items-center gap-3"
              >
                <span className="hidden md:inline text-xs uppercase tracking-wider text-[#9A938A]">
                  {user.name}
                </span>
                <button
                  type="button"
                  data-testid="logout-btn"
                  onClick={onLogout}
                  className="text-sm text-[#6B655D] hover:text-[#2D2926] hover:bg-[#F2EFE9] rounded-full px-3 py-2 transition-colors inline-flex items-center gap-1"
                  aria-label="Log out"
                >
                  <LogOut size={16} strokeWidth={1.5} />
                </button>
              </div>
            </>
          ) : (
            <>
              <Link
                to="/pricing"
                data-testid="nav-pricing"
                className="text-sm text-[#6B655D] hover:text-[#2D2926] hover:bg-[#F2EFE9] rounded-full px-4 py-2 transition-colors"
              >
                Pricing
              </Link>
              <Link
                to="/about"
                data-testid="nav-about"
                className="text-sm text-[#6B655D] hover:text-[#2D2926] hover:bg-[#F2EFE9] rounded-full px-4 py-2 transition-colors"
              >
                About
              </Link>
              <Link
                to="/login"
                data-testid="nav-login"
                className="text-sm text-[#6B655D] hover:text-[#2D2926] hover:bg-[#F2EFE9] rounded-full px-4 py-2 transition-colors"
              >
                Sign in
              </Link>
              <Link
                to="/register"
                data-testid="nav-register"
                className="bg-[#2D2926] text-white hover:bg-[#1A1715] rounded-full px-5 py-2 text-sm transition-colors"
              >
                Get started
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
